// react
import React from 'react';
import ReactMarkdown from 'react-markdown';

// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import { Box, Typography } from '@mui/material';

type AssistantMessagePart =
  | {
      type: 'text';
      content: string;
    }
  | {
      type: 'toolCall';
      content: string; // Using any to match TanStack AI's ToolCall type
    };

interface UserMessageProps {
  parts: AssistantMessagePart[]; // Using object to match TanStack AI's MessagePart type
}

export const UserMessage: React.FC<UserMessageProps> = ({ parts }) => {
  const { t } = useTranslation('ai-assistant');

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        mb: 2,
        px: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: '85%',
          p: 2,
          borderRadius: 2,
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          boxShadow: (theme) =>
            theme.palette.mode === 'light'
              ? '0 1px 2px rgba(0,0,0,0.1)'
              : '0 1px 2px rgba(0,0,0,0.4)',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 1,
            justifyContent: 'flex-start',
          }}
        >
          {/* <Box
            sx={{
              width: 24,
              height: 24,
              borderRadius: '50%',
              bgcolor: 'primary.contrastText',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <Typography
              sx={{
                fontSize: '0.75rem',
                fontWeight: 700,
                color: 'primary.main',
              }}
            >
              U
            </Typography>
          </Box> */}
          <Typography variant="caption" fontWeight="bold" sx={{ opacity: 0.9 }}>
            {t('messages.you')}
          </Typography>
        </Box>

        {parts.map((part, idx) => {
          if (part.type === 'text') {
            return (
              <Box
                key={idx}
                sx={{
                  '& p': { margin: '0.5em 0' },
                  '& code': {
                    bgcolor: (theme) =>
                      theme.palette.mode === 'light'
                        ? 'rgba(0,0,0,0.1)'
                        : 'rgba(255,255,255,0.1)',
                    p: 0.5,
                    borderRadius: 1,
                    fontFamily: 'monospace',
                  },
                  '& pre': {
                    bgcolor: (theme) =>
                      theme.palette.mode === 'light'
                        ? 'rgba(0,0,0,0.1)'
                        : 'rgba(255,255,255,0.1)',
                    p: 1.5,
                    borderRadius: 1,
                    overflow: 'auto',
                  },
                  '& ul, & ol': { pl: 2 },
                }}
              >
                <ReactMarkdown>{part.content || ''}</ReactMarkdown>
              </Box>
            );
          }
          return null;
        })}
      </Box>
    </Box>
  );
};
